import { Box } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  .description-title {
    text-transform: none;
    ${({ theme }) => theme.above.laptop`
      font-size: 53px;
      line-height: 90px;
      margin-top: -170px;
      text-transform: none;
    `}
  }
`

export const WrapperPlayer = styled(Box)`
  padding-top: ${({ wrapHeight }) => wrapHeight};
  position: relative;

  .react-player {
    left: 0;
    position: absolute;
    top: 0;
  }
`
